import React from "react";

const mapStyles = {
  height: "100vh",
  overflow: "none",
  position: "relative",
  width: "100%",
};

// Mapbox requires its container to be empty, so the overlays (controls,
// legend, results panel) are siblings positioned over it
const containerStyles = {
  height: "100%",
  width: "100%",
};

const MapIFramePAP = React.forwardRef(function MapIFramePAP({ children }, ref) {
  return (
    <section id="public-map" style={mapStyles}>
      <div ref={ref} style={containerStyles} />
      {children}
    </section>
  );
});

export default MapIFramePAP;
